import { SET_FIXTURES_ROUTE, SET_FAVORITE_TYPE_ROUTE } from "./actionTypes";

const initialState = {
  currentRoute: "tatca",
  currentFavoriteTypeRoute: "",
};

export const FixtureRouteReducer = (
  state: any = initialState,
  action: any
) => {
  switch (action.type) {
    case SET_FIXTURES_ROUTE:
      return {
        ...state,
        currentRoute: action.payload,
      };
    case SET_FAVORITE_TYPE_ROUTE:
      return {
        ...state,
        currentFavoriteTypeRoute: action.payload,
      };
    default:
      return state;
  }
};

export default FixtureRouteReducer;
